"use client";

import Cookies from "js-cookie";
import {
  LOCALE_COOKIE_DOMAIN_DEFAULT,
  LOCALE_COOKIE_MAX_AGE_SECONDS,
  LOCALE_COOKIE_NAME,
  LOCALE_COOKIE_PATH,
  LOCALE_TO_COOKIE_MAP,
} from "./constants";
import { getEnv } from "@/env";

const setLocaleCookie = async (locale: string) => {
  const cookieValue = LOCALE_TO_COOKIE_MAP[locale] || locale;
  const expires = new Date(Date.now() + LOCALE_COOKIE_MAX_AGE_SECONDS * 1000);

  Cookies.set(LOCALE_COOKIE_NAME, cookieValue, {
    expires,
    path: LOCALE_COOKIE_PATH,
    sameSite: "lax",
    domain: getEnv("COOKIE_DOMAIN") || LOCALE_COOKIE_DOMAIN_DEFAULT,
  });
};

export default setLocaleCookie;
